import Modal from "../../components/modal/modal.component";
import InputComponent from "../../components/input/input.component";
import DatepickerComponent from "../../components/datepicker/datepicker.component";
import { Controller, useForm } from "react-hook-form";
import TextareaComponent from "../../components/textarea/textarea.component";
import usePeriod from "../../hooks/period.use";
import { to } from "../../polyfill";
import { RemindersService } from "../../services/operation/reminders";
import AlertPeriod from "../../components/alert-period/alert-period";
import InvalidFeedback from "../../components/invalid-feedback/invalid-feedback.component";
import Button from "../../components/button/button.component";
import { useEffect } from "react";
import { UtilsService } from "../../services/utils";

function FormModal({ data, show, setShow }: any) {
  const { currentPeriod } = usePeriod();
  
  const defaultValues = {
    _id: '',
    period: currentPeriod._id,
    name: '',
    date: '',
    comments: '',
  };

  const { watch, setValue, reset, register, handleSubmit, control, formState: { errors, isSubmitting, isValid }, } = useForm<typeof defaultValues>({
    mode: 'onChange',
    defaultValues,
  });

  const _id = watch('_id');

  const submit = async(form: typeof defaultValues) => {
    const [error, data] = await to(RemindersService.save(form));
    if(error) {
      alert(error.message)
    } else {
      setShow(true)
      reset(defaultValues);
    }
  }

  useEffect(() => {
    if(data) {
      reset({ ...data, date: UtilsService.dateFormat(data.date, 'YYYY-MM-DD'), period: currentPeriod._id })
    }

    if(!show) {
      reset(defaultValues);
    }
  }, [show, data])
  

  return (
    <Modal show={show}>
      <div className="modal-header">
        <h3 className="modal-title">{ !_id ? 'Agregar': 'Editar'} recordatorio</h3>
        <div
          className="btn btn-icon btn-sm btn-active-light-primary ms-2"
          onClick={setShow}
        >
          <i className="ki-duotone ki-cross fs-1">
            <span className="path1" />
            <span className="path2" />
          </i>
        </div>
      </div>
      <div className="modal-body">
        <div className="mb-5">
          <AlertPeriod />
        </div>

        <div className="alert alert-dismissible bg-light-info d-flex flex-column flex-sm-row w-100 p-5 mb-10">
          <i className="ki-duotone ki-notification-bing fs-2hx text-info me-4 mb-5 mb-sm-0">
            <span className="path1" />
            <span className="path2" />
            <span className="path3" />
          </i>
          <div className="d-flex flex-column pe-0 pe-sm-10">
            <span>
              Los recordatorios se enviarán por correo y como notificación push a los usuarios de esta empresa.
            </span>
          </div>
          
        </div>


        <div className="mb-5">
          <InputComponent label="Nombre *" {...register('name', { required: true })} errors={errors.name} />
        </div>

        <div className="mb-5">
           <Controller
              name="date"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value},
                fieldState: { error },
              }) => (
                <>
                  <DatepickerComponent
                    label="Fecha de recordatorio *"
                    errors={error}
                    onChange={onChange}
                    value={value}
                  />
                  <InvalidFeedback error={error} />
                </>
              )}
            />
        </div>

        <div className="mb-5">
          <TextareaComponent label="Observaciones *" {...register('comments', { required: true })} errors={errors.comments} />
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-light" type="button" onClick={setShow}>
          Cancelar
        </button>
        <Button className="btn btn-primary" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>
          Guardar
        </Button>
      </div>
    </Modal>
  );
}

export default FormModal;
